import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'

export const Item = ({ name, price, options, onClick, activeType, duration, id }) => {
  const { t } = useTranslation('common')

  return (
    <div className='tip-oglasa-item'>
      <p className='tip-oglasa-naziv'>{name}</p>
      <p className='tip-oglasa-cena'>{price}&euro;</p>
      <ul className='tip-oglasa-lista'>
        {
          options.map((item, index) => <li key={index}>- {item}</li>)
        }
        {
          duration ? <li key='duration'>- {t('Trajanje')} <span>{duration} {t('dana')}</span></li> : null
        }
      </ul>
      <a
        className={`${activeType === id ? `active` : null}`}
        href='javascript:void (0)'
        data-id={id}
        onClick={onClick}
      >{t('Izaberi')}</a>
    </div>
  )
}

Item.propTypes = {
  id: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  options: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  duration: PropTypes.number,
  onClick: PropTypes.func,
  activeType: PropTypes.any
}

Item.defaultProps = {
  desc: []
}
